import React, {useEffect, useState} from "react";
import Input from "@core/inputs/Input";
import DefaultButton from "@core/buttons/electrons/DefaultButton";
import Select from "@core/dropdowns/Select";
import {hideSpinner, showSpinner} from "@redux/spinner/Action";
import API from "@utils/plugins/API";
import {useDispatch} from "react-redux";
import {useHistory} from "react-router-dom";
import {formatAmount, showError} from "@utils/helpers";


const PreOrderForm = ({
                        product,
                        ref,
                        selectedColor,
                        selectedMemory,
                        selectedTimeline,
                        selectedInstallment,
                        cities,
                        paymentType,
                        step,
                        setPaymentType,
                        setStep,
                        saveAmount
                      }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [showDealBanner, setShowDealBanner] = useState(false);
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [cityId, setCityId] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setShowDealBanner(paymentType === "only-phone" && step === "registration")
  }, [paymentType, step])

  const onReserve = () => {
    dispatch(showSpinner('Please wait...'))
    setLoading(true)
    const data = {
      campaign_id: product.campaign_id,
      product_id: product.id,
      color_id: selectedColor.id,
      memory_id: selectedMemory.id,
      timeline_id: selectedTimeline?.id,
      installment_id: selectedInstallment?.id,
      city_id: cityId,
      name: name,
      phone_number: phone
    }

    API.post('preorder-campaign/save-form', data).then(() => {
      dispatch(hideSpinner());
      setLoading(false)
      history.push({
        pathname: '/reservation-success',
        state: {successfulReservation: "true"}
      });
    }).catch((err) => {
      dispatch(hideSpinner());
      setLoading(false)
      showError(err?.response?.data?.message);
    })
  }

  return (
    <div className="flex flex-col sm:flex-row">
      <div className="flex-4 flex flex-col mt-10"
           style={{flex: 1}}>
        {showDealBanner && <div onClick={() => {
          setPaymentType('with-plan');
          setStep('pre-order')
        }}
                                className="3xl:max-w-screen-xl flex justify-center rounded-lg mx-auto w-full p-5 text-center mb-6 text-base md:text-xl font-sans leading-4 text-gray-700 font-semibold">
        </div>}
        <div className="font-bold text-2xl text-gray-700 font-sans tracking-tight mb-4 text-center mt-5">
          Regjistrohu më poshtë
        </div>
        <Input
          placeholder={"Emër Mbiemër"}
          onChange={(e) => setName(e.target.value)}
        />
        <Input
          containerClass={'my-2'}
          placeholder={'06XXXXXXXX'}
          onChange={(e) => setPhone(e.target.value)}
        />
        <Select
          containerClass={'my-2'}
          options={cities}
          placeholder={"Qyteti"}
          onChange={setCityId}
        />
        <div className={'flex flex-col justify-center mt-8 mb-8'}>
          <DefaultButton disabled={!name || !cityId || !phone || !selectedColor || !selectedMemory}
                         loading={loading} label="Porosit Tani" onClick={onReserve}/>
        </div>
      </div>
      <div ref={ref}/>
    </div>
  );
}

export default PreOrderForm;
